import { rtbInstance } from "@api/instance";

export const getMe = () => {
  return rtbInstance.get("/me");
};
